import { Box, Card } from '@mui/material';
import { ComponentProps, ReactElement, ReactNode } from 'react';
import { FilterForm, ListBase, Pagination, TopToolbar } from 'react-admin';

interface DetachedListPageProps extends Omit<ComponentProps<typeof ListBase>, 'children'> {
  actions?: ReactNode;
  children: ReactNode;
  filters?: ReactElement[];
  pagination?: ReactElement | false;
}

export default function DetachedListPage({
  actions,
  children,
  filters,
  pagination,
  ...listBaseProps
}: DetachedListPageProps): ReactElement {
  const hasFilters = !!filters?.length;
  const paginationElement = pagination === false ? null : (pagination ?? <Pagination />);

  return (
    <ListBase {...listBaseProps}>
      <Box sx={{ minWidth: 0, overflowX: 'hidden' }}>
        {actions && (
          <TopToolbar
            sx={{
              position: 'fixed',
              top: 62,
              right: 5,
              zIndex: 1000,
              minHeight: 0,
              padding: 0.5,
              backgroundColor: 'background.paper',
              borderRadius: 1,
              boxShadow: 1,
            }}
          >
            {actions}
          </TopToolbar>
        )}
        {hasFilters && <FilterForm filters={filters} />}
        <Card sx={{ minWidth: 0 }}>
          <Box sx={{ minWidth: 0, overflowX: 'auto' }}>{children}</Box>
        </Card>
        {paginationElement}
      </Box>
    </ListBase>
  );
}
